export const SUPERVISOR_KEY = 'supervisor';
export const SUPERVISOR_STALE_TIME = 30_000;
export const SUPERVISOR_PAGE_SIZE = 50;
export const SUPERVISOR_BATCH_LIMIT = 100;
export const SUPERVISOR_ACTIVITY_SEARCH_DEBOUNCE_MS = 800;
export const SUPERVISOR_MATCH_TOLERANCE = 10;
export const SUPERVISOR_HEALTHY_MATCH_PERCENT = 80;
export const SUPERVISOR_TABS = ['all', 'new_video', 'no_video'] as const;
